










































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import LoaderSpinner from '@/components/LoaderSpinner.vue';
import {
  ModalCloseEvent,
  ModalOpenEvent,
} from '@/types';


@Component({
  name: 'base-modal',
  components: {
    LoaderSpinner,
  },
})
export default class BaseModal extends Vue {
  @Prop({ type: String, required: true })
  name!: string;

  @Prop({ type: String, required: true })
  width!: string;

  @Prop({ type: String, required: true })
  height!: string;

  @Prop({ type: Number })
  maxHeight!: number;

  @Prop({ type: String })
  wrapperClass?: string;

  @Prop({ type: String })
  title?: string;

  @Prop({ type: Boolean })
  showClose?: boolean;

  @Prop({ type: Boolean })
  hideCancelButton?: boolean;

  @Prop({ type: String })
  cancelText?: string;

  @Prop({ type: String })
  confirmText?: string;

  @Prop({ type: Boolean })
  cancelDisabled?: boolean;

  @Prop({ type: Boolean })
  confirmDisabled?: boolean;

  @Prop({ type: Function })
  beforeOpen?: (event: ModalOpenEvent) => {};

  @Prop({ type: Function })
  beforeClose?: (event: ModalCloseEvent) => {};

  @Prop({ type: Function })
  onOpened?: () => {};

  @Prop({ type: Function })
  onCancel?: () => {};

  @Prop({ type: Function })
  onConfirm?: () => {};

  @Prop({ type: Boolean })
  confirmOnEnter?: boolean;

  @Prop({ type: Boolean })
  confirmOnAltEnter?: boolean;

  @Prop({ type: Boolean })
  showLoadingState?: boolean;

  public $refs!: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    modal: any;
  };

  public updateSize(): void {
    this.$refs.modal.setInitialSize();
  }

  private handleBeforeOpen(event: ModalOpenEvent): void {
    if (this.beforeOpen) {
      this.beforeOpen(event);
    }

    if (this.confirmOnEnter) {
      document.addEventListener('keypress', this.handleKeyPress);
    }
  }

  private handleBeforeClose(event: ModalCloseEvent): void {
    if (this.beforeClose) {
      this.beforeClose(event);
    }

    if (this.confirmOnEnter) {
      document.removeEventListener('keypress', this.handleKeyPress);
    }
  }

  private handleOpened(): void {
    if (this.onOpened) {
      this.onOpened();
    }
  }

  private handleCancel(): void {
    if (this.onCancel) {
      this.onCancel();
    }

    this.$modal.hide(this.name);
  }

  private handleConfirm(): void {
    if (this.confirmDisabled) {
      return;
    }

    if (this.onConfirm) {
      this.onConfirm();
    }
  }

  private handleKeyPress(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.handleEnterPress(event);
    }
  }

  private handleEnterPress(event: KeyboardEvent): void {
    if (this.confirmOnEnter) {
      this.handleConfirm();
    }

    if (this.confirmOnAltEnter && event.altKey) {
      this.handleConfirm();
    }
  }
}
